import React from "react";
import AnimationRevealPage from "../../../../helpers/AnimationRevealPage.js";
import tw from "twin.macro";
import Header from "../../../../Components/headers/PageHeader";
import MainFeature1 from "../../../../Components/Features/TwoColWithButton.js";
import Features from "../../../../Components/Features/ThreeColumnPages";
import {
  FaTools,
  FaShoppingCart,
  FaRocket,
  FaShieldAlt,
  FaMobileAlt,
  FaStar,
} from "react-icons/fa";

// Styled Components
const Subheading = tw.span`uppercase tracking-wider text-sm`;
const Heading = tw.h1`text-2xl md:text-4xl lg:text-5xl font-bold`;
const Description = tw.p`text-base md:text-lg lg:text-xl`;

export const SecureEcommerceSolutionsInDubai = () => {
  return (
    <AnimationRevealPage>
      {/* Header Section */}
      <Header from="Secure E-commerce Solutions in Dubai" />

      {/* Hero Section */}
      <MainFeature1
        subheading={<Subheading>Safety First</Subheading>}
        heading={
          <Heading>
            Secure <span tw="text-primary-500">E-commerce Solutions</span> in
            Dubai
          </Heading>
        }
        description={
          <Description>
            At MilaajBrandset, we provide secure e-commerce solutions in
            **Dubai**, building online stores with advanced security features to
            protect your business and customers. Trust us to deliver safe,
            reliable, and high-performing platforms.
          </Description>
        }
        imageSrcs={[
          "https://images.unsplash.com/photo-1563013544-824ae1b704d3?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1000&q=80", // Secure e-commerce shopping
          "https://images.unsplash.com/photo-1581092918056-0c4c3acd3789?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1000&q=80", // Digital security concept
          "https://images.unsplash.com/photo-1517245386807-bb43f82c33c4?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1000&q=80", // Team working on web development
        ]}
        widths={["55%", "60%", "70%"]}
        heights={["45%", "60%", "35%"]}
        imageColumnStyle="height: 400px;"
        imageStyle="width: 45%; height: 60%;"
        imagePositions={[
          "left: 35%; top: 20%;",
          "right: 30%; top: 10%;",
          "left: 32%; bottom: 20%;",
        ]}
        primaryButtonText="Secure Your Store Today"
        buttonRounded={true}
        textOnLeft={false}
      />

      {/* Key Benefits Section */}
      <Features
        subheading={<Subheading>Why Choose Us?</Subheading>}
        heading="Top-Tier Security for Dubai E-commerce"
        description="We prioritize safety without compromising performance."
        cards={[
          {
            icon: <FaShieldAlt color="#ff5464" size={40} />,
            title: "Advanced Encryption",
            description: "SSL and data encryption for secure transactions.",
          },
          {
            icon: <FaTools color="#ff5464" size={40} />,
            title: "Regular Security Updates",
            description: "Stay protected with timely patches and upgrades.",
          },
          {
            icon: <FaShoppingCart color="#ff5464" size={40} />,
            title: "Safe Payment Gateways",
            description: "Trusted integrations for secure checkouts.",
          },
          {
            icon: <FaRocket color="#ff5464" size={40} />,
            title: "Fast & Secure Hosting",
            description: "Optimized servers with DDoS protection.",
          },
          {
            icon: <FaMobileAlt color="#ff5464" size={40} />,
            title: "Mobile Security",
            description: "Safe shopping experiences across devices.",
          },
          {
            icon: <FaStar color="#ff5464" size={40} />,
            title: "Trusted Expertise",
            description: "Dubai’s leader in secure e-commerce solutions.",
          },
        ]}
      />

      {/* Our Process Section */}
      <MainFeature1
        subheading={<Subheading>How We Work</Subheading>}
        heading="Our Secure Development Process"
        description={
          <Description>
            We build secure e-commerce stores with precision:
            <ul tw="mt-4 list-disc pl-6">
              <li>Assessment: Identify your security needs and risks.</li>
              <li>Design: Create a secure, user-friendly store layout.</li>
              <li>Development: Implement encryption and secure features.</li>
              <li>Testing: Rigorous checks for vulnerabilities.</li>
              <li>Launch: Deploy a fortified, high-performing store.</li>
              <li>Monitoring: Ongoing security audits and support.</li>
            </ul>
          </Description>
        }
        imageSrcs={[
          "https://images.unsplash.com/photo-1566669437687-7040a6926753?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1000&q=80", // Secure checkout process
          "https://images.unsplash.com/photo-1573164713988-8665fc963095?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1000&q=80", // Security monitoring dashboard
          "https://images.unsplash.com/photo-1571171637578-41bc2dd41cd2?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1000&q=80", // Development team collaboration
        ]}
        widths={["60%", "55%", "70%"]}
        heights={["60%", "45%", "35%"]}
        imageColumnStyle="height: 400px;"
        imageStyle="width: 45%; height: 60%;"
        imagePositions={[
          "right: 30%; top: 10%;",
          "left: 35%; bottom: 20%;",
          "right: 32%; bottom: 10%;",
        ]}
        primaryButtonText="Learn More"
        buttonRounded={true}
        textOnLeft={true}
      />

      {/* Success Stories Section */}
      <Features
        subheading={<Subheading>Success Stories</Subheading>}
        heading="Secure Success in Dubai"
        description="Our solutions protect and empower businesses."
        cards={[
          {
            icon: <FaShieldAlt color="#ff5464" size={40} />,
            title: "Zero Breaches",
            description: "Client store secure for over two years.",
          },
          {
            icon: <FaShoppingCart color="#ff5464" size={40} />,
            title: "Customer Trust",
            description: "Secure store boosted sales by 160%.",
          },
          {
            icon: <FaStar color="#ff5464" size={40} />,
            title: "High Satisfaction",
            description: "98% approval for secure solutions.",
          },
        ]}
      />

      {/* Call-to-Action Section */}
      <MainFeature1
        subheading={<Subheading>Ready for a Safe Store?</Subheading>}
        heading="Secure E-commerce Solutions in Dubai"
        description={
          <Description>
            Partner with MilaajBrandset for secure e-commerce solutions in
            Dubai. Protect your business and customers with a fortified online
            store—contact us today!
          </Description>
        }
        imageSrcs={[
          "https://images.unsplash.com/photo-1553877522-43269d4ea984?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1000&q=80", // Team celebrating project success
          "https://images.unsplash.com/photo-1557821552-17105176677c?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1000&q=80", // E-commerce payment security
          "https://images.unsplash.com/photo-1535303311164-664fc9ec6532?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1000&q=80", // Dubai cityscape
        ]}
        widths={["55%", "60%", "70%"]}
        heights={["45%", "60%", "35%"]}
        imageColumnStyle="height: 400px;"
        imageStyle="width: 45%; height: 60%;"
        imagePositions={[
          "left: 35%; top: 20%;",
          "right: 30%; top: 10%;",
          "left: 32%; bottom: 20%;",
        ]}
        primaryButtonText="Contact Us Now"
        buttonRounded={true}
        textOnLeft={false}
      />
    </AnimationRevealPage>
  );
};
